import '../assets/NcInputConfirmCancel-CSzzPx0i.css';
import o from "../Components/NcButton.mjs";
import { r as i, m as l, a } from "./_l10n-BZu8wI2q.mjs";
import { A as u } from "./ArrowRight-C3BxTDjF.mjs";
import { C as c } from "./Close-BtO5TPBO.mjs";
import { n as p } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
i(l);
const s = {
  name: "NcInputConfirmCancel",
  components: {
    NcButton: o,
    ArrowRight: u,
    Close: c
  },
  props: {
    /**
     * If this element is used on a primary element set to true for primary styling.
     */
    primary: {
      default: !1,
      type: Boolean
    },
    placeholder: {
      default: "",
      type: String
    },
    value: {
      default: "",
      type: String
    }
  },
  emits: [
    "input",
    "confirm",
    "cancel"
  ],
  data() {
    return {
      labelConfirm: a("Confirm changes"),
      labelCancel: a("Cancel changes")
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(r) {
        this.$emit("input", r);
      }
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
    focusInput() {
      this.$refs.input.focus();
    }
  }
};
var f = function() {
  var e = this, n = e._self._c;
  return n("div", { staticClass: "app-navigation-input-confirm" }, [n("form", { on: { submit: function(t) {
    return t.preventDefault(), e.confirm.apply(null, arguments);
  }, keydown: function(t) {
    return !t.type.indexOf("key") && e._k(t.keyCode, "esc", 27, t.key, ["Esc", "Escape"]) || t.ctrlKey || t.shiftKey || t.altKey || t.metaKey ? null : (t.stopPropagation(), t.preventDefault(), e.cancel.apply(null, arguments));
  }, click: function(t) {
    t.stopPropagation(), t.preventDefault();
  } } }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: e.valueModel, expression: "valueModel" }], ref: "input", staticClass: "app-navigation-input-confirm__input", attrs: { type: "text", placeholder: e.placeholder }, domProps: { value: e.valueModel }, on: { input: function(t) {
    t.target.composing || (e.valueModel = t.target.value);
  } } }), n("NcButton", { attrs: { "native-type": "submit", type: "primary", "aria-label": e.labelConfirm }, on: { click: function(t) {
    return t.stopPropagation(), t.preventDefault(), e.confirm.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [n("ArrowRight", { attrs: { size: 20 } })];
  }, proxy: !0 }]) }), n("NcButton", { attrs: { "native-type": "reset", type: e.primary ? "primary" : "tertiary", "aria-label": e.labelCancel }, on: { click: function(t) {
    return t.stopPropagation(), t.preventDefault(), e.cancel.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [n("Close", { attrs: { size: 20 } })];
  }, proxy: !0 }]) })], 1)]);
}, m = [], y = /* @__PURE__ */ p(
  s,
  f,
  m,
  !1,
  null,
  "dcf0becf",
  null,
  null
);
const v = y.exports;
export {
  v as N
};
